import { VSimpleTable } from 'vuetify/lib'

/**
 * @file DDv2用シンプルテーブル
 * @namespace components
 */

/**
 * @see https://vuetifyjs.com/ja/api/v-simple-table/
 * @vue-prop {Boolean} [fixedHeader=true]
 * @vue-prop {Boolean} [dense=true]
 */
export default VSimpleTable.extend({
  name: 'DdSimpleTable',
  props: {
    fixedHeader: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    }
  }
})
